export default __webpack_public_path__ + "static/media/background-photo.1ca9a6f0.jpeg";